import { render, staticRenderFns } from "./FieldsModal.vue?vue&type=template&id=64a2068b&scoped=true&"
import script from "./FieldsModal.vue?vue&type=script&lang=js&"
export * from "./FieldsModal.vue?vue&type=script&lang=js&"
import style0 from "./FieldsModal.vue?vue&type=style&index=0&id=64a2068b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2068b",
  null
  
)

export default component.exports